import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  deviceRow: {
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#EDEBED',
    },
  },
  disconnectedDevice: {
    background: 'rgba(240, 81, 70, 0.2)',
  },
  TableCell: {
    ...theme.tables.tableCell,
    padding: '10px 15px',
    verticalAlign: 'top',
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  nameColumn: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flex: 1,
  },
  nameText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '20ch',
  },
  idText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '20ch',
    fontSize: '12px',
    color: '#545964',
  },
  vendorColumn: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  vendorNameText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '15ch',
  },
  vendorIdText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '15ch',
    fontSize: '12px',
    color: '#545964',
  },
  modelText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '15ch',
  },
  caColumn: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  caSerialText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '15ch',
  },
  caLineText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '15ch',
    fontSize: '12px',
    color: '#545964',
  },
  arrowCell: {
    ...theme.tables.tableCell,
    padding: '0 5px',
    width: 40,
  },
  expandArrow: {
    fontSize: '14px',
    color: '#545964',
    transition: 'transform 0.2s ease',
    transform: 'rotate(0deg)',
  },
  expandArrowOpen: {
    transform: 'rotate(90deg)',
  },
  aggregationText: {
    color: '#545964',
    fontStyle: 'italic',
    fontSize: '13px',
  },
  statusCell: {
    color: '#545964',
  },
  connectedDevice: {
    color: '#5FBA82',
  },
  highlight: {
    background: '#EDEBED',
  },
  // Inline single-unit styles
  mediumWidth: {
    width: '200px !important',
    maxWidth: '200px !important',
  },
  inputRoot: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    fontSize: '14px',
    lineHeight: 'normal',
    '& button': {
      background: 'transparent !important',
      border: 'none !important',
      outline: 'none !important',
      boxShadow: 'none !important',
    },
    '& .select-trigger-open': {
      border: 'none !important',
      outline: 'none !important',

    }
  },
  selectTrigger: {
    width: '130px !important',
  },
  textOverflow: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 'calc(100% - 25px)',
  },
  appUnitNameCell: {
    minWidth: '180px',
  },
  viewContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '4px',
  },
  titleText: {
    fontSize: '13px',
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '15ch',
  },
  editIcon: {
    padding: 2,
    flexShrink: 0,
    '& svg': {
      fontSize: 14,
      color: '#545964',
    },
  },
  editContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '2px',
  },
  editInput: {
    fontSize: '13px',
    padding: '4px 8px',
  },
  editAction: {
    padding: 2,
    flexShrink: 0,
  },
  menuItemWithLine: {
    padding: '0 16px',
    height: '1px',
    minHeight: '1px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export default useStyles;
